module.exports = __webpack_public_path__ + "static/img/homework.3577535f.svg";